import { render, staticRenderFns } from "./MoveRequest.vue?vue&type=template&id=03084500&"
import script from "./MoveRequest.vue?vue&type=script&lang=ts&"
export * from "./MoveRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports